import React from "react";

function Favorite({ isFavorite }) {
  let classes =
    "absolute top-2 right-2  hearts flex self-center justify-self-start text-red-700";
  classes += isFavorite ? "text-red-700" : "text-slate-800";
  if (isFavorite) {
    classes += " text-yellow-400";
  } else {
    classes += " hidden";
  }
  return (
    <div className={classes}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    </div>
  );
}

export default Favorite;
